import { MODE } from "../../variables";

export const DATADOG_APPLICATION_ID = import.meta.env?.VITE_DATADOG_APPLICATION_ID as string;
export const DATADOG_CLIENT_TOKEN = import.meta.env?.VITE_DATADOG_CLIENT_TOKEN as string;
export const DATADOG_SITE = "datadoghq.eu";
export const DATADOG_ENV = resolveDataDogEnv(MODE ?? import.meta.env.NODE_ENV ?? "prod");

function resolveDataDogEnv(env: string) {
    switch (true) {
        case /^dev((elopment)?)$/.test(env):
            return "dev";
        case /^(stg|staging)$/.test(env):
            return "staging";
        default:
            return "prod";
    }
}
